import { render, staticRenderFns } from "./VideoPromoDialog.vue?vue&type=template&id=24720550&scoped=true&"
import script from "./VideoPromoDialog.vue?vue&type=script&lang=js&"
export * from "./VideoPromoDialog.vue?vue&type=script&lang=js&"
import style0 from "./VideoPromoDialog.vue?vue&type=style&index=0&id=24720550&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24720550",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24720550')) {
      api.createRecord('24720550', component.options)
    } else {
      api.reload('24720550', component.options)
    }
    module.hot.accept("./VideoPromoDialog.vue?vue&type=template&id=24720550&scoped=true&", function () {
      api.rerender('24720550', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dialogs/VideoPromoDialog.vue"
export default component.exports